import { formatBasicCurrency } from '../../../shared/utils/misc';

/**
 * Payment plan detail with info passed from the parent app
 */
Vue.component('pay-plan-details-basic', {
  template: `
  <div>
    <div class="md-flex">
      <div class="w-md-50 m-r-md-20">
        <p><span class="label">Term Period</span> {{ frequencyDetails.termPeriodMonths }} Months</p>
      </div>
      <div class="w-md-50 m-r-md-20">
        <p><span class="label">Account Number</span> {{ accountId }}</p>
      </div>
    </div>
    <div class="md-flex">
      <div class="w-md-50 m-r-md-20">
        <p><span class="label">Down Payment Amount</span> {{ initialPaymentAmount }}</p>
      </div>
      <div class="w-md-50 m-r-md-20">
        <p><span class="label">Down Payment Due Before</span> {{ initialPaymentDueDate }}</p>
      </div>
    </div>
    <div class="md-flex">
      <div class="w-md-50 m-r-md-20">
        <p><span class="label">Monthly Payment Amount</span> {{ paymentAmount }} + current bill</p>
      </div>
      <div class="w-md-50 m-r-md-20">
        <p><span class="label">Account Balance</span> {{ frequencyDetails.totalAgreementAmount }}</p>
      </div>
    </div>
  </div>
  `,

  /**
   * Props array
   */
  props: ['accountId', 'initialPaymentAmount', 'initialPaymentDueDate', 'frequencyDetails'],

  /**
   * Data function
   */
  data() {
    return {
      paymentAmount: '',
    }
  },

  mounted() {
    this.paymentAmount = formatBasicCurrency(this.frequencyDetails.paymentAmount);
  },

});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/vue/components/payPlanDetailsBasic.js